                    //<script type="application/javascript">
                                        import Vue from "vue";
                                        import App from '/home/bitrix/ext_www/epotos.ru/www/local/templates/epotos/components/bitrix/news.list/dealers/template.vue';

                    export function init(sel, _data) {
                        const app = new Vue(App)
                        Vue.util.extend(app.$data, _data);
                        app.$mount(sel)
                    }
                    //</script>
                    


// WEBPACK FOOTER //
// ./apps/vue-x4ZPam5dvjwLvgY/src/client-entry.js